export const capitalizeFirstLetter = (value: string) => {
  if (value && value.length) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  } else {
    return "";
  }
};
